export default {
  // list
  'container_transport_order.column.orderId': '托单ID',
  'container_transport_order.column.ladingOrderId': '提单ID',
  'container_transport_order.column.transportNo': '运单编号',
  'container_transport_order.column.sortNo': '第几程运输',
  'container_transport_order.column.primaryFlag': '是否为主程运输',
  'container_transport_order.column.transportType': '运输类型',
  'container_transport_order.column.transportCompanyId': '运输公司',
  'container_transport_order.column.transportCompanyName': '运输公司',
  'container_transport_order.column.transportTime': '承运时间',
  'container_transport_order.column.shippingTerms': '运输条款',
  'container_transport_order.column.settlementMethod': '结算方式',
  'container_transport_order.column.businessType': '业务类型',
  'container_transport_order.column.loadingPoint': '装货地',
  'container_transport_order.column.loadingContactName': '装货地联系人',
  'container_transport_order.column.loadingContactPhone': '装货地联系电话',
  'container_transport_order.column.unloadingPoint': '卸货地',
  'container_transport_order.column.unloadingContactName': '卸货地联系人',
  'container_transport_order.column.unloadingContactPhone': '卸货地联系电话',
  'container_transport_order.column.entrepotId': '中转港ID',
  'container_transport_order.column.stopArea': '靠区',
  'container_transport_order.column.createBy': '创建人',
  'container_transport_order.column.updateBy': '更新人',
  'container_transport_order.column.createTime': '创建时间',
  'container_transport_order.column.updateTime': '更新时间',
  'container_transport_order.column.dataSource': '数据来源',
  'container_transport_order.column.remark': '备注',
  'container_transport_order.column.status': '状态',
  // edit
  'container_transport_order.edit.title': '编辑集装箱运输单',
  'container_transport_order.add.title': '新增集装箱运输单',
  'container_transport_order.edit.success': '编辑成功',
  'container_transport_order.add.success': '新增成功',
  'container_transport_order.form.orderId.required': '托单ID不能为空',
  'container_transport_order.form.ladingOrderId.required': '提单ID不能为空',
  'container_transport_order.form.sortNo.required': '第几程运输不能为空',
  'container_transport_order.form.primaryFlag.required': '是否为主程运输不能为空',
  'container_transport_order.form.transportType.required': '运输类型不能为空',
  'container_transport_order.form.transportCompanyId.required': '运输公司不能为空',
  'container_transport_order.form.transportCompanyName.required': '运输公司不能为空',
  'container_transport_order.form.transportTime.required': '承运时间不能为空',
  'container_transport_order.form.businessType.required': '业务类型不能为空',
  'container_transport_order.form.loadingPoint.required': '装货地不能为空',
  'container_transport_order.form.unloadingPoint.required': '卸货地不能为空',
  'container_transport_order.form.orderId': '托单ID',
  'container_transport_order.form.orderId.placeholder': '请输入托单ID',
  'container_transport_order.form.ladingOrderId': '提单ID',
  'container_transport_order.form.ladingOrderId.placeholder': '请输入提单ID',
  'container_transport_order.form.sortNo': '第几程运输',
  'container_transport_order.form.sortNo.placeholder': '请输入第几程运输',
  'container_transport_order.form.primaryFlag': '是否为主程运输',
  'container_transport_order.form.primaryFlag.placeholder': '请输入是否为主程运输',
  'container_transport_order.form.transportType': '运输类型',
  'container_transport_order.form.transportType.placeholder': '请输入运输类型',
  'container_transport_order.form.transportCompanyId': '运输公司',
  'container_transport_order.form.transportCompanyId.placeholder': '请输入运输公司',
  'container_transport_order.form.transportCompanyName': '运输公司',
  'container_transport_order.form.transportCompanyName.placeholder': '请输入运输公司',
  'container_transport_order.form.transportTime': '承运时间',
  'container_transport_order.form.transportTime.placeholder': '请输入承运时间',
  'container_transport_order.form.shippingTerms': '运输条款',
  'container_transport_order.form.shippingTerms.placeholder': '请输入运输条款',
  'container_transport_order.form.settlementMethod': '结算方式',
  'container_transport_order.form.settlementMethod.placeholder': '请输入结算方式',
  'container_transport_order.form.businessType': '业务类型',
  'container_transport_order.form.businessType.placeholder': '请输入业务类型',
  'container_transport_order.form.loadingPoint': '装货地',
  'container_transport_order.form.loadingPoint.placeholder': '请输入装货地',
  'container_transport_order.form.loadingContactName': '联系人',
  'container_transport_order.form.loadingContactName.placeholder': '请输入装货地联系人',
  'container_transport_order.form.loadingContactPhone': '联系电话',
  'container_transport_order.form.loadingContactPhone.placeholder': '请输入装货地联系电话',
  'container_transport_order.form.unloadingPoint': '卸货地',
  'container_transport_order.form.unloadingPoint.placeholder': '请输入卸货地',
  'container_transport_order.form.unloadingContactName': '联系人',
  'container_transport_order.form.unloadingContactName.placeholder': '请输入卸货地联系人',
  'container_transport_order.form.unloadingContactPhone': '联系电话',
  'container_transport_order.form.unloadingContactPhone.placeholder': '请输入卸货地联系电话',
  'container_transport_order.form.entrepotId': '中转港ID',
  'container_transport_order.form.entrepotId.placeholder': '请输入中转港ID',
  'container_transport_order.form.stopArea': '靠区',
  'container_transport_order.form.stopArea.placeholder': '请输入靠区',
}
